interface Feature {
  img: string;
  title: string;
  description: string;
}

interface FeatureProps {
  features: Feature[];
}

const Features = ({ features }: FeatureProps) => {
  if (!features?.length) {
    return null;
  }

  return (
    <>
      <h2 className="brand-heading-lg text-center text-primary">小院特色</h2>
      <div className="mt-8 grid grid-cols-2 gap-y-10 text-primary lg:grid-cols-4">
        {features.map((feature, index) => (
          <div className="flex flex-col items-center gap-2" key={index}>
            <img src={feature.img} alt={feature.title} className="h-20 w-20" loading="lazy" />
            <h4 className="brand-heading-sm mt-4 font-serif font-normal text-secondary">
              {feature.title}
            </h4>
            <p className="brand-text-md text-secondary">{feature.description}</p>
          </div>
        ))}
      </div>
    </>
  );
};

export default Features;
